module.exports = __webpack_public_path__ + "img/service-calculate-1.93e644db.svg";